import { render } from "./WorkspaceNotificationConfiguration.vue?vue&type=template&id=5512423c&scoped=true"
import script from "./WorkspaceNotificationConfiguration.vue?vue&type=script&lang=js"
export * from "./WorkspaceNotificationConfiguration.vue?vue&type=script&lang=js"

import "./workspace-notification-configuration.scss?vue&type=style&index=0&id=5512423c&lang=scss&scoped=true"

import exportComponent from "/build/src/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5512423c"]])

export default __exports__